<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('attachmentManage.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-primary" @click="_addRow">
              <i class="el-icon-plus"></i>{{ $t('attachmentManage.action.add') }}
            </el-button>
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="_queryMethod">
              <i class="el-icon-refresh"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input size="small" v-model="conditions.nameLike"
              :placeholder="$t('attachmentManage.search.keywordPlaceholder')" class="figma-search-input" clearable />
            <el-button size="small" class="figma-btn-search" @click="_queryMethod">
              <i class="el-icon-search"></i>{{ $t('common.search') }}
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="name" :label="$t('attachmentManage.table.name')" width="100">
            <template slot-scope="scope"><span class="figma-community-name">{{ scope.row.name }}</span></template>
          </el-table-column>
          <el-table-column prop="fileSaveName" :label="$t('attachmentManage.table.fileName')" min-width="140" align="center">
            <template slot-scope="scope">{{ scope.row.fileSaveName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="fileType" :label="$t('attachmentManage.table.fileType')" width="100" align="center">
            <template slot-scope="scope">{{ scope.row.fileType || '-' }}</template>
          </el-table-column>
          <el-table-column prop="fileSize" :label="$t('attachmentManage.table.fileSize')" width="100" align="center">
            <template slot-scope="scope">{{ scope.row.fileSize || '-' }}</template>
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('attachmentManage.table.uploadTime')" width="160" align="center">
            <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
          </el-table-column>
          <el-table-column prop="statusCd" :label="$t('attachmentManage.table.state')" width="80" align="center">
            <template slot-scope="scope">
              <span :class="['status-tag', getStateClass(scope.row.statusCd)]">{{ scope.row.statusCd === '0' ? $t('attachmentManage.table.stateNormal') : '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operation')" fixed="right" width="120">
            <template slot-scope="scope">
              <span class="action-links">
                <a class="action-link" @click="_editRow(scope.row)">{{ $t('attachmentManage.action.edit') }}</a>
                <span class="link-separator"></span>
                <a class="action-link action-link-danger" @click="_deleteRow(scope.row)">{{ $t('attachmentManage.action.delete') }}</a>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination">
        <span class="pagination-total">共{{ pagination.total }}条</span>
        <el-pagination :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.size" layout="prev, pager, next, jumper" :total="pagination.total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        <el-select v-model="pagination.size" size="small" class="pagination-size-select">
          <el-option label="10条/页" :value="10" /><el-option label="20条/页" :value="20" /><el-option label="50条/页" :value="50" />
        </el-select>
      </div>
    </div>

    <!-- 上传/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" custom-class="figma-dialog">
      <el-form :model="formData" label-width="80px" size="small">
        <el-form-item :label="$t('attachmentManage.table.name')">
          <el-input v-model="formData.name" :placeholder="$t('attachmentManage.audit.namePlaceholder')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('attachmentManage.audit.file')">
          <el-upload
            class="upload-demo"
            action="#"
            :auto-upload="false"
            :on-change="handleFileChange"
            :file-list="fileList">
            <el-button size="small" type="primary">{{ $t('attachmentManage.audit.selectFile') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">{{ $t('attachmentManage.audit.cancel') }}</el-button>
        <el-button size="small" type="primary" @click="_submitForm">{{ $t('attachmentManage.audit.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listAttachmentManage, saveAttachmentManage, deleteAttachmentManage } from '@/api/platform/platformApi'
import { uploadFile } from '@/api/system/paymentPoolApi'

export default {
  name: 'AttachmentManageList',
  data() {
    return {
      conditions: { nameLike: '' },
      tableData: [],
      pagination: { current: 1, size: 10, total: 0 },
      dialogVisible: false,
      dialogTitle: '',
      formData: { attachmentId: '', name: '' },
      fileList: []
    }
  },
  created() {
    this._listData(this.pagination.current, this.pagination.size)
  },
  methods: {
    _listData(page, size) {
      listAttachmentManage({ ...this.conditions, page, row: size }).then(res => {
        this.tableData = Array.isArray(res.data) ? res.data : []
        this.pagination.total = res.total || 0
      }).catch(error => {
        console.error('请求失败处理', error)
      })
    },
    _queryMethod() {
      this.pagination.current = 1
      this._listData(this.pagination.current, this.pagination.size)
    },
    _addRow() {
      this.dialogTitle = this.$t('attachmentManage.action.add')
      this.formData = { attachmentId: '', name: '' }
      this.fileList = []
      this.dialogVisible = true
    },
    _editRow(row) {
      this.dialogTitle = this.$t('attachmentManage.action.edit')
      this.formData = { ...row }
      this.fileList = []
      this.dialogVisible = true
    },
    _deleteRow(row) {
      this.$confirm(this.$t('attachmentManage.audit.deleteConfirm'), this.$t('attachmentManage.audit.deleteTitle'), {
        confirmButtonText: this.$t('attachmentManage.action.delete'),
        cancelButtonText: this.$t('attachmentManage.audit.cancel'),
        type: 'warning'
      }).then(() => {
        deleteAttachmentManage({ attachmentId: row.attachmentId }).then(() => {
          this.$message.success(this.$t('attachmentManage.audit.deleteSuccess'))
          this._queryMethod()
        }).catch(error => { console.error('删除失败', error) })
      }).catch(() => {})
    },
    handleFileChange(file) {
      this.formData.file = file.raw
      this.formData.fileType = file.raw.type || ''
      this.formData.fileSize = file.raw.size || 0
    },
    async _submitForm() {
      if (!this.formData.name) {
        this.$message.warning('请输入附件名称')
        return
      }
      let _fileName = ''
      let _realFileName = ''
      if (this.formData.file) {
        const uploadFormData = new FormData()
        uploadFormData.append('uploadFile', this.formData.file)
        try {
          const uploadRes = await uploadFile(uploadFormData, {})
          _fileName = uploadRes.fileName || ''
          _realFileName = uploadRes.realFileName || ''
        } catch (error) {
          console.error('文件上传失败', error)
          this.$message.error('文件上传失败')
          return
        }
      }
      const params = {
        name: this.formData.name,
        fileSaveName: _fileName,
        fileRealName: _realFileName,
        fileType: this.formData.fileType || '',
        fileSize: this.formData.fileSize || 0
      }
      if (this.formData.attachmentId) {
        params.attachmentId = this.formData.attachmentId
      }
      saveAttachmentManage(params).then(() => {
        this.$message.success(this.$t('attachmentManage.audit.saveSuccess'))
        this.dialogVisible = false
        this._queryMethod()
      }).catch(error => {
        console.error('保存失败', error)
        this.$message.error(error.message || '保存失败')
      })
    },
    getStateClass(state) {
      return { '0': 'status-occupied', '1': 'status-occupied', '2': 'status-danger', '3': 'status-warning' }[state] || 'status-unsold'
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this._listData(this.pagination.current, val)
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this._listData(val, this.pagination.size)
    },
    headerCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '500', fontFamily: 'PingFang SC', height: '50px' }
    },
    cellStyle({ row }) {
      const rowIndex = this.tableData.indexOf(row)
      return rowIndex % 2 === 1
        ? { background: '#F8FBFF', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' }
        : { background: 'white', color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px' }
    }
  }
}
</script>

<style scoped>
.admin-room-container { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px; gap: 12px; }
.figma-page-title { font-size: 16px; font-weight: 500; color: #1D2129; font-family: 'PingFang SC'; margin-bottom: 8px; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; margin-bottom: 16px; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.figma-btn-group { display: flex; align-items: center; gap: 8px; }
.figma-btn-primary { height: 38px; border-radius: 10px !important; background: #0E76FF !important; border: none !important; color: white !important; font-size: 14px; font-weight: 500; padding: 0 20px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-primary:hover { background: #409EFF !important; }
.figma-btn-recycle { height: 38px; border-radius: 10px !important; background: rgba(14, 118, 255, 0.14) !important; border: none !important; color: #0E76FF !important; font-size: 14px; font-weight: 500; padding: 0 20px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-recycle:hover { background: rgba(14, 118, 255, 0.22) !important; }
.figma-btn-refresh { height: 38px; width: 38px; border-radius: 10px !important; border: 1px solid #DCE6F5 !important; background: white !important; color: #6A7282 !important; display: inline-flex; align-items: center; justify-content: center; }
.figma-btn-refresh:hover { border-color: #0E76FF !important; color: #0E76FF !important; }
.figma-search-group { display: flex; align-items: center; gap: 8px; margin-left: auto; }
.figma-search-input { width: 256px; height: 38px; }
.figma-search-input >>> .el-input__inner { border-radius: 10px; border: none; outline: 1px #0E76FF solid; outline-offset: -1px; height: 38px; font-size: 14px; background: white; }
.figma-btn-search { height: 38px; border-radius: 10px !important; border: none !important; outline: 1px #0E76FF solid !important; outline-offset: -1px; color: #0E76FF !important; background: white !important; font-size: 14px; font-weight: 500; padding: 0 16px; display: inline-flex; align-items: center; gap: 6px; }
.figma-btn-search:hover { background: rgba(14, 118, 255, 0.08) !important; }
.figma-table-section { flex: 1; padding: 0 24px; overflow: auto; }
.figma-table-section >>> .el-table { border-radius: 8px; overflow: hidden; border: none; }
.figma-table-section >>> .el-table__header th { background: #EBF2FA !important; border: none !important; }
.figma-table-section >>> .el-table__body td { border: none !important; border-bottom: 1px solid #F0F0F0 !important; }
.figma-table-section >>> .el-table__body tr:nth-child(even) td { background: #F8FBFF; }
.figma-community-name { color: #0E76FF; font-weight: 500; }
.status-tag { display: inline-block; padding: 4px 12px; border-radius: 8px; font-size: 14px; font-weight: 400; }
.status-occupied { background: rgba(33, 185, 86, 0.10); color: #21B956; border: 1px solid #21B956; }
.status-unsold { background: rgba(140, 155, 180, 0.10); color: #8C9BB4; border: 1px solid #8C9BB4; }
.status-danger { background: rgba(251, 44, 54, 0.10); color: #FB2C36; border: 1px solid #FB2C36; }
.status-warning { background: rgba(255, 153, 0, 0.10); color: #FF9900; border: 1px solid #FF9900; }
.action-links { display: flex; align-items: center; gap: 8px; }
.action-link { color: #0E76FF; font-size: 14px; cursor: pointer; text-decoration: none; }
.action-link:hover { text-decoration: underline; }
.action-link-danger { color: #FB2C36; }
.link-separator { color: #DCE6F5; }
.figma-pagination { display: flex; align-items: center; justify-content: flex-end; padding: 16px 24px; gap: 16px; border-top: 1px solid #DCE6F5; }
.pagination-total { font-size: 14px; color: #1D2129; }
.figma-pagination >>> .el-pagination { display: flex; align-items: center; }
.figma-pagination >>> .el-pager li { border-radius: 8px; }
.figma-pagination >>> .el-pager li.active { background: #E8F3FF; color: #0E76FF; }
.pagination-size-select { width: 92px; }
.pagination-size-select >>> .el-input__inner { border-radius: 8px; background: #F2F3F5; border: none; font-size: 14px; }
</style>
